<template lang="pug">
div.dynamic-comission
  .comission-title {{$t('Текущая комиссия:')}}
  template(v-if="rules && !isLoading")
    ul.rules
      li(v-for="r of rules").rule  {{r.rule.base}}%
        template(v-if="r.rule.fix.length > 0")
          |
          |
          | + {{r.rule.fix[0].amount|money(r.rule.fix[0].currency)}} {{r.rule.fix[0].currency|publicCurrency(true)}}
        template(v-if="r.rule.min.amount > 0")
          |
          |
          | (min. {{r.rule.min.amount|money(r.rule.min.currency)}} {{r.rule.min.currency|publicCurrency(true)}})
    //template  (v-if="!isLoading")
      div Обновитcя через {{timerCounter}} сек.
  div(v-if="isLoading").refreshing {{$t('refreshing')}}
  div(v-if="isLoadingFail").text-danger {{$t('text_error')}}
</template>

<script lang="ts">
import Vue from "vue";
import {Component, Prop} from "vue-property-decorator";
import {WebFormModel} from "capitalist-shared/src/core/model";
import {RemoteRequestState} from "capitalist-shared/src/core/remote";
import {MoneyFormatFilter} from "@/models/filters/money";
import {frontofficeCurrencyFilter} from "@/models/core/currency";
import httpAxiosApi from "capitalist-shared/src/core/axios.errors.handle";


class DynamicFeeValueModel extends WebFormModel {

  loadingStatus = new RemoteRequestState();

  reloadFee(system: string | string[]) {
    this.loadingStatus.loadStart();
    return httpAxiosApi.post('/webapi/finance/payout', {
      call: 'getTax',
      system: system
    }).then(response => {
      this.loadingStatus.loadEnd();
      return response.data.model.rules;
    }).catch(err => {
      this.checkAxiosError(err);
      this.loadingStatus.loadError();
      throw err;
    })
  }
}


@Component({
  name: "DynamicFeeValueText",
  filters: {
    money: MoneyFormatFilter,
    publicCurrency: frontofficeCurrencyFilter
  }
})
export default class DynamicFeeValueText extends Vue {
  @Prop({default: 'USDTERC20,USDTTRC20'})
  system: string | string[]

  model = new DynamicFeeValueModel();

  rules = null

  pause = false

  timerId = null

  timerCounter = 3
  timerInterval = 120

  mounted() {
    this.startTimer();
    window.addEventListener('blur', this.pauseTimer);
    window.addEventListener('focus', this.playTimer);
  }

  beforeDestroy() {
    clearInterval(this.timerId);
  }

  startTimer() {
    this.timerId = setInterval(this.tickTimer, 1000);
  }

  tickTimer() {
    if (this.timerCounter == 0) {
      if (!this.pause)
      {
        this.timerCounter = this.timerInterval;
        this.reload();
      }
    } else {
      this.timerCounter--;
    }
  }

  pauseTimer() {
    this.pause = true;
  }

  playTimer() {
    this.pause = false;
  }

  get isLoading() {
    return this.model.loadingStatus.isLoading || (this.timerCounter == 0);
  }

  get isLoadingFail() {
    return this.model.loadingStatus.isError;
  }

  reload() {
    this.model.reloadFee(this.system).then(rules => {
      this.rules = rules;
    }).catch(err => {
      if (this.timerCounter > 0)
          this.startTimer();
    })
  }

}
</script>

<style scoped lang="less">
.dynamic-comission {
  margin-top: 10px;
  .comission-title {
    font-weight: bolder;
  }
  .refreshing {
    margin: 7px 0 0 0;
  }
  .rules {
    list-style: disc;
    margin: 7px 0 0 0;
    padding: 0 0 0 20px;
    .rule {
      margin: 2px 0;
      padding: 0;
    }
  }
}
.text-danger {
  color: #ee4538;
}
</style>

<i18n>
{
  "en": {
    "refreshing": "Updating...",
    "Текущая комиссия:": "Current commission:",
    "text_error": "Error while loading data"
  },
  "ru": {
    "refreshing": "Обновление...",
    "text_error": "Ошибка получения данных"
  }
}
</i18n>
